import type { PortalRelationship, PortalProfileDto, PortalFoundProfileDto } from '../infrastructure/portalProfiles.api';

// Pure display helpers for portal profiles. No I/O, no React — safe to unit-test in isolation.

/** Two-letter initials for an avatar, from a (already-masked) display name. Falls back to "?". */
export function profileInitials(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const letters = parts.slice(0, 2).map((p) => p[0]).join('');
  return letters.toUpperCase();
}

/** i18n key for a relationship type, e.g. 'Parent' -> 'profile.relationship.parent'. */
export function relationshipKey(relationship: PortalRelationship): string {
  return `profile.relationship.${relationship.toLowerCase()}`;
}

/** The name shown for a profile: the portal alias if set, else the (masked) patient display name. */
export function profileName(profile: Pick<PortalProfileDto, 'displayAlias' | 'patientDisplayName'>): string {
  const alias = profile.displayAlias?.trim();
  return alias && alias.length > 0 ? alias : profile.patientDisplayName;
}

/** Compact secondary line: "Sunrise Family Clinic · b. 1992" (year omitted when unknown). */
export function profileSubtitle(
  profile: Pick<PortalProfileDto | PortalFoundProfileDto, 'clinicName' | 'dobYear'>
): string {
  return profile.dobYear ? `${profile.clinicName} · b. ${profile.dobYear}` : profile.clinicName;
}
